// Translation: Terms of service > Landing > Form (Turkish)
export default Object.freeze({})
